<template>
  <v-layout row wrap data-qa="depositdetails-layout-ha6d4r">
    <v-layout wrap class="ml-2" data-qa="depositdetails-layout-odlj0i">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="depositdetails-flex-g12hfo">
        <v-container class="pa-6 pl-12" data-qa="depositdetails-container-51fpt">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="depositdetails-flex-kxpkx">
            <v-row no-gutters data-qa="depositdetails-row-smnd3p">
              <v-layout row wrap class="pb-2" align-center data-qa="depositdetails-layout-qzekeh">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <v-layout column class="pb-2" data-qa="depositdetails-layout-752aqr">
                    <font class="display-1 font-weight-thin white--text pt-4 pl-2"
                      >{{ $t("termdepositDetails.label") }}</font
                    >
                    <!--Product Description-->
                    <font
                      class="text-h5 font-weight-thin white--text pl-2" v-if="showProductDescription"
                      >{{ productDescription }}</font
                    >
                  </v-layout>
              </v-layout>
            </v-row>
            <v-row data-qa="depositdetails-row-c1xvz8">
              <v-layout wrap class="pl-4" data-qa="depositdetails-layout-s5hiks">
                <v-layout column wrap data-qa="depositdetails-layout-1dtws9">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="depositdetails-flex-m8a72">
                    <font class="subheading-1 font-weight-medium white--text"
                      >{{  $t("accountDetails.accountNumber") }}</font
                    >
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="depositdetails-flex-wjaiw3">
                     <font class="text-h5 font-weight-bold white--text">{{$formatter.formatAccount(accountNumber, iban)}}</font>
                  </v-flex>
                </v-layout>
                <v-layout column wrap data-qa="depositdetails-layout-9l40q5">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="depositdetails-flex-9p5kr">
                    <font class="subheading-1 font-weight-medium white--text"
                      >{{ $t("termdepositDetails.depositAmt") }}</font
                    >
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="depositdetails-flex-kz9ck1">
                    <font class="text-h5 font-weight-bold white--text" :color="$formatter.currency.isNegativeBalance(availableBalance) ? errorColor : ''">{{
                      availableBalance
                    }}</font>
                  </v-flex>
                </v-layout>

                <v-layout column wrap data-qa="depositdetails-layout-vkgqff">
                  <v-flex xs6 sm4 md6 lg4 xl4 class="px-1" data-qa="depositdetails-flex-orqmg3">
                    <font class="subheading font-weight-medium white--text"
                      >{{ $t("termdepositDetails.maturityAmount") }}</font
                    >
                  </v-flex>
                  <v-flex xs6 sm5 md5 lg4 xl4 class="px-1" data-qa="depositdetails-flex-iqmrjk">
                    <font class="text-h5 font-weight-bold white--text" :color="$formatter.currency.isNegativeBalance(maturityAmt) ? errorColor : ''">{{
                      maturityAmt
                    }}</font>
                  </v-flex>
                </v-layout>

                <v-layout justify-start class="pa-2"  data-qa="depositdetails-layout-zdq98">
                  <v-flex sm8 xs8 md4 lg4 xl4 class="text-right pr-3" v-if="showDepositBreakButton && !isJointAccount" data-qa="depositdetails-flex-c6qic">
                    <v-btn
                      :disabled="!(productDetails.actionList &&
                        productDetails.actionList.indexOf('break') !== -1) || coolingPeriodCheck || isSameDayBreaking || isEndDateCommonForAllAccounts"
                      @click="
                        breakDeposit(
                          depositDetailsSection1,
                          depositDetailsSection2
                        )
                      "
                      outlined
                      color="white"
                      class="text-none py-2 px-4"
                      data-qa="breakDeposit"
                      >{{ $t("termdepositDetails.break") }}</v-btn
                    >
                  </v-flex>
                  <v-flex sm4 xs4 md4 lg4 xl4 v-if="(!isSmeLogin || !isJointAccount) && (!isJointAccount || isModeOfOperationExcluded)" data-qa="depositdetails-flex-5aaj4m">
                    <v-tooltip top v-if="!withinMaturityDateRange" data-qa="depositdetails-tooltip-5nfpcx">
                      <template v-slot:activator="{ on }">
                        <div v-on="on" data-qa="depositdetails-div-n0cod">
                          <v-btn
                            :disabled="isAmendDisabled"
                            @click="
                              amendDeposit(
                                depositDetailsSection1,
                                depositDetailsSection2
                              )
                            "
                            outlined
                            dark
                            color="white"
                            class="text-none py-2 px-4"
                            data-qa="amendDeposit"
                            >{{ $t("termdepositDetails.amend") }}
                            <v-icon class="pl-2 material-symbols-outlined" v-if="!withinMaturityDateRange" data-qa="depositdetails-icon-ays4tp">help</v-icon>
                          </v-btn>
                        </div>
                      </template>
                      <font class="white--text">
                        {{ $t("termdepositDetails.disabledAmendTooltip") }}
                      </font>
                    </v-tooltip>
                    <v-btn v-else
                            :disabled="isAmendDisabled"
                            @click="
                              amendDeposit(
                                depositDetailsSection1,
                                depositDetailsSection2
                              )
                            "
                            outlined
                            dark
                            color="white"
                            class="text-none"
                            data-qa="amendDeposit py-2 px-4"
                            >{{ $t("termdepositDetails.amend") }}
                            <v-icon class="pl-2" v-if="!withinMaturityDateRange" data-qa="depositdetails-icon-xhifm">mdi-help-circle-outline</v-icon>
                          </v-btn>
                    </v-flex>
                </v-layout>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
      <v-flex lg10 class="pt-12" data-qa="depositdetails-flex-ynf3gh">
        <v-card v-if="isDetailsPermitted && (depositDetailsSection1.length || depositDetailsSection2.length)" tile class="py-2 pt-4" data-qa="depositdetails-card-2749mc">
          <DisplayDetails
            v-if="depositDetailsSection1.length"
            :config="{
              title: $t('termdepositDetails.accountInfo'),
              dataList: depositDetailsSection1,
              translation: 'termdepositDetails',
            }"
            class="pl-5"
          />
          <v-divider data-qa="depositdetails-divider-v07ihp"  class="pa-3" />
          <DisplayDetails
            v-if="depositDetailsSection2.length"
            :config="{
              title: $t('termdepositDetails.maturityInfo'),
              dataList: depositDetailsSection2,
              translation: 'termdepositDetails',
            }"
            class="pl-5"
          />
        </v-card>
        <v-card v-if="(isSmeLogin && enableRoleBasedAccess) ? !isDetailsPermitted : false" tile class="py-2 pt-4">
          <v-row
            no-gutters
            justify="center"
            class="ma-6 ml-0"
          >
            <div outlined class="text-center pa-6">
              <p :class="{ 'ma-6 mt-0 px-12': !$vuetify.breakpoint.smAndDown }">
                <font :color="errorColor" class="body-2">{{$t('errors.common.restrictedSection')}}</font>
              </p>
            </div>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
    <v-flex class="mb-1" v-if="tips.enabled" data-qa="depositdetails-flex-4ov2qh">
      <v-alert icon="mdi-information-outline" class="v-alert--info"
        v-for="(tip, i) in tips.tipMessages"
        :key="tip"
        :data-qa="`depositdetails-alert-4ov3qh-${i}`"
      >
          <font class="body-2 font-weight-regular">
            {{ $t(`screenTips.${tip}`) }}
          </font>
      </v-alert>
    </v-flex>
    <v-flex v-if="(!isJointAccount && isSameDayBreaking && config.params.accountStatus !== 'MATURED') && !isEndDateCommonForAllAccounts && showDepositBreakButton" xs12 sm12 md10 lg8 xl6 class="text-left pa-4" data-qa="depositdetails-flex-mroscj">
      <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="depositdetails-alert-z6et3">
        <font class="body-2">
          {{ $t("termdepositDetails.sameDayBreakRestrictMsg") }}
        </font>
      </v-alert>
    </v-flex>
    <v-flex v-if="(coolingPeriodCheck && !isSameDayBreaking && config.params.accountStatus !== 'MATURED') && !isEndDateCommonForAllAccounts && showDepositBreakButton" xs12 sm12 md10 lg8 xl6 class="text-left pa-4" data-qa="depositdetails-flex-gwo93o">
     <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="depositdetails-alert-s6kd5p">
        <font class="body-2">
          {{ $t("termdepositDetails.coolingOffMsg") }}
        </font>
      </v-alert>
    </v-flex>
    <v-flex v-if="isEndDateCommonForAllAccounts && showDepositBreakButton" xs12 sm12 md10 lg8 xl6 class="text-left pa-4" data-qa="depositdetails-flex-p3pjy7">
     <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="depositdetails-alert-ipn4gs">
        <font class="body-2">
          {{ $t("termdepositDetails.disabledBreakForAccountsWithEndDateCommon") }}
        </font>
      </v-alert>
    </v-flex>
  </v-layout>
</template>

<script>
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import commonService from '@/service/commonService.js'
import appSettings from '@/plugins/appSettings'
import _ from 'lodash'
import store from '@/core/store'
import moment from 'moment'

export default {
  name: 'DepositDetails',
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  components: {
    DisplayDetails
  },
  data () {
    return {
      depositDetailsSection1: [],
      depositDetailsSection2: [],
      appSettings,
      productDetails: null,
      accountNumber: null,
      productName: null,
      lastBreakageDate: '',
      capitalAccountBICId: '',
      sortCode: this.$appSettings.defaultConfigurations.sortCode,
      rolloverProductId: '',
      rolloverAmount: undefined,
      rolloverPercentage: undefined,
      availableBalance: undefined,
      maturityAmt: undefined,
      coolingOffEndDate: '',
      startDate: '',
      iban: '',
      modeOfOperation: '',
      excludedModeOfOperation: this.$appSettings.uiFieldsDisplayConfigurations.jointModeOfOperationsForTransfer.exclusionList,
      tips: {
        enabled: false,
        tipMessages: []
      },
      nominatedAccountsConfig: this.$appSettings.defaultConfigurations.nominatedAccounts,
      isJointAccount: false,
      isMaturityInstructionsAvailable: true,
      showProductDescription: this.$appSettings.defaultConfigurations.accountDetailsScreen.enableProductDescriptionInBanner,
      productDescription: '',
      maturityDate: '',
      enableAmendMIOnMaturityMonth: this.$appSettings.defaultConfigurations.maturityInstruction.deposits.enableAmendMIOnMaturityMonth,
      enableDepositBreakButton: this.$appSettings.defaultConfigurations.showDepositBreakButton,
      isEndDateCommonForAllAccounts: false,
      currentProductSummary: undefined,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      permissions: [],
      isDetailsPermitted: false,
      isAmendPermitted: false,
      isBreakPermitted: false,
      checkPermissions: {
        details: 'DEPOSITS_VIEW_DETAILS',
        amend: 'AMEND_MI',
        break: 'DEPOSIT_BREAK'
      }
    }
  },
  async created () {
    this.setTips(this.defaultAccountType)
    // Fetch permissions for SME user
    this.permissions = store.getters['profileStore/profileData']?.permissions
    this.isDetailsPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes(this.checkPermissions.details) : true
    this.isAmendPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes(this.checkPermissions.amend) : true
    this.isBreakPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes(this.checkPermissions.break) : true
    if (this.$route.params.product !== undefined) {
      this.productDetails = this.$route.params.product
      this.accountNumber = this.productDetails
        ? this.productDetails.accountId
        : this.$route.params.accountId
    } else {
      this.productDetails = {
        actionList: []
      }
    }
    this.accountId = this.config.params.accountId
    this.accountName = this.config.params.accountName || this.getCustomerName()
    this.productName = this.config.params.productName
    this.defaultAccountType = this.config.params.defaultAccountType
    await this.getFixedDepositDetails(this.accountNumber)
  },
  computed: {
    coolingPeriodCheck () {
      if (this.coolingOffEndDate) {
        const d = new Date().toLocaleDateString().split('/')
        const currentDate = `${d[2]}-${d[0]}-${d[1]}`
        return moment(currentDate).isBefore(this.coolingOffEndDate)
      }
      return false
    },
    isSameDayBreaking () {
      if (this.startDate) {
        const d = new Date().toLocaleDateString().split('/')
        const currentDate = `${d[2]}-${d[0]}-${d[1]}`
        return moment(currentDate).isSame(this.startDate, 'day')
      }
      return false
    },
    withinMaturityDateRange () {
      if (this.enableAmendMIOnMaturityMonth) {
        const depositMaturityDate = new Date(this.maturityDate)
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const firstDay = new Date(depositMaturityDate.getFullYear(), depositMaturityDate.getMonth(), 1)
        const beforeMaturity = new Date(depositMaturityDate.getFullYear(), depositMaturityDate.getMonth(), depositMaturityDate.getDate() - 1)
        return today >= firstDay && today <= beforeMaturity
      }
      return true
    },
    isAmendDisabled () {
      return (this.isSmeLogin && this.enableRoleBasedAccess) ? !this.isAmendPermitted : !(this.productDetails?.actionList?.includes('amend')) || !this.withinMaturityDateRange
    },
    showDepositBreakButton () {
      return (this.isSmeLogin && this.enableRoleBasedAccess) ? this.isBreakPermitted : this.enableDepositBreakButton
    },
    isModeOfOperationExcluded () {
      return !this.excludedModeOfOperation.includes(this.modeOfOperation)
    }
  },
  methods: {
    getCustomerName () {
      const data = store.getters['profileStore/profileData'].customerDetails
      if (data) {
        this.accountName = data.fullName || 'Roger Moore'
        return this.accountName
      }
    },
    getNavigationIcon () {
      return this.getSvgIconSrc('Deposit2')
    },
    convertToCapitalisedSentence (sentence) {
      return this.$formatter.convertCase.convertToCapitalisedSentence(sentence)
    },
    async getFixedDepositDetails (accountNumber) {
      const response = await commonService.getFixedDepositDetails(accountNumber)
      if (response && response.customerId) {
        this.currentProductSummary = await commonService.getTDProductSummary(response.productIdentifier)
        if (this.currentProductSummary.isEndDateCommonForAllAccounts) {
          this.isEndDateCommonForAllAccounts = this.currentProductSummary.isEndDateCommonForAllAccounts
        }
        this.modeOfOperation = response.modeOfOperation
        this.coolingOffEndDate = response.coolingOffEndDate
        this.lastBreakageDate = response.lastBreakageDate
        this.capitalAccountBICId = response.capitalAccountBICId
        this.startDate = response.startDate
        this.iban = response.iban
        this.isJointAccount = response.accountOwnership.toLowerCase() === 'joint'
        let tenorFrequency = ''
        this.productDescription = response.productDescription
        this.maturityDate = response.maturityDate
        this.productDetails.jointHolderNames = response.jointHolderNames
        if (
          response.interestPayout === 'pip' ||
        response.interestPayout === 'PIP'
        ) {
          response.interestPayout = 'Periodic'
        }
        tenorFrequency = parseInt(response.duration) > 1 ? _.capitalize(response.durationType) : _.capitalize(response.durationType.slice(0, -1))
        this.availableBalance = this.$formatter.currency.format(
          response.currentBalance.value, response.isoCurrencyCode
        )
        this.maturityAmt = this.$formatter.currency.format(
          response.maturityAmount.value, response.isoCurrencyCode
        )
        this.depositDetailsSection1.push(
          {
            label: 'productDescription',
            value: response.productDescription
          },
          {
            label: 'status',
            value: this.$t(`systemEnums.termDeposit.${response.status}`)
          },
          {
            label: 'sortCode',
            value: this.sortCode
          },
          {
            label: 'interestRate',
            value: response.interestRate + '%'
          },
          {
            label: 'duration',
            value: `${response.duration} ${tenorFrequency}`
          },
          {
            label: 'startDate',
            value: this.$formatter.formatDate(response.startDate)
          },
          {
            label: this.nominatedAccountsConfig.enableNominatedAccountFeatures && response.allowFundingFromOtherBank ? 'fundingAccountIdNominated' : 'fundingAccountId',
            value: response.fundingAccountId
          },
          {
            label: 'jointAccount',
            value: this.isJointAccount ? this.$t('common.yes') : this.$t('common.no')
          }
        )
        // exclude display items
        this.depositDetailsSection1 = this.depositDetailsSection1.filter(item =>
          !this.$appSettings.uiFieldsDisplayConfigurations.termDepositEnquiry.exclusionList.includes(item.label)
        )
        if (response.capitalAccountBICId) {
          // index 3 = ROI
          this.depositDetailsSection1.splice(3, 1) // To hide interest rate field when external TD with 0 bal
        }
        const capitalizationMethodNotAvailable = ['NO-INSTRUCTION', 'MANUALREDEMPTION', 'NOT-APPLICABLE']
        if (capitalizationMethodNotAvailable.includes(response.capitalizationMethod)) {
          this.isMaturityInstructionsAvailable = false
        }
        const isPayawayPIP = response.interestPayout === 'Periodic' && (response.capitalizationMethod === 'PAYAWAYCAPITAL' || response.capitalizationMethod === 'PAYAWAYPRINCIPAL')
        this.depositDetailsSection2.push(
          {
            label: 'maturityDate',
            value: this.$formatter.formatDate(response.maturityDate)
          },
          {
            label: 'interestAmount',
            value: this.$formatter.currency.format(response.interestAmount.value, response.isoCurrencyCode)
          },
          {
            label: this.nominatedAccountsConfig.enableNominatedAccountFeatures && response?.capitalAccountBICId
              ? 'payCapitalToAccountNominated' : 'payCapitalToAccount',
            value: this.getMaturityAccount(response)
          },
          {
            label: 'capitalizationMethod',
            value: (response.rolloverAmount.value > 0 && response.rolloverAmount.value < response.maturityAmount.value) ||
            (response.rolloverPercentage < 100 && response.rolloverPercentage > 0)
              ? this.$t('systemEnums.maturityInstructions.PAYAWAY-PARTIAL')
              : isPayawayPIP ? this.$t('systemEnums.maturityInstructions.PIPPAYAWAYPRINCIPAL') : this.$t(`systemEnums.maturityInstructions.${response.capitalizationMethod}`)
          }
        )

        if (response.interestPayout === 'Periodic') {
          this.depositDetailsSection2.push({
            label: this.nominatedAccountsConfig.enableNominatedAccountFeatures && response.interestAccountBICId ? 'payInterestToAccountNominated' : 'payInterestToAccount',
            value: response.interestAccountBICId
              ? `${response.payInterestToAccount} - ${response.interestAccountBICId}`
              : response.payInterestToAccount
          })
        }
        // Rollover Sub Product Display
        if (response.rolloverProductId) {
          const productIdDesc = await commonService.getTDProductSummary(response.rolloverProductId)
          this.depositDetailsSection2.push(
            {
              label: 'rolloverSubProduct',
              value: `${productIdDesc.productDescription} - ${response.rolloverProductId}`
            }
          )
        }
        if (response.capitalizationMethod === 'CAPITALISE') {
          // Partial-Credit is defined to be Rollover Amount < Maturity Amount AND Rollover Amount > 0
          if ((response.rolloverAmount.value < response.maturityAmount.value) && (response.rolloverAmount.value > 0) && (response.rolloverPercentage === 0)) {
            this.depositDetailsSection2.push(
              {
                label: 'payawayCredit',
                value: this.$formatter.currency.format(response.maturityAmount.value - response.rolloverAmount.value, response.maturityAmount.currency)
              },
              {
                label: 'rolloverAmount',
                value: this.$formatter.currency.format(response.rolloverAmount.value, response.maturityAmount.currency)
              }
            )
          }
          // Partial-Credit is defined to be Rollover Percentage < 100 AND Rollover Percentage > 0
          if ((response.rolloverPercentage < 100) && (response.rolloverPercentage > 0)) {
            const rolloverValue = (response.maturityAmount.value) * (response.rolloverPercentage / 100)
            this.depositDetailsSection2.push(
              {
                label: 'payawayCredit',
                value: this.$formatter.currency.format(response.maturityAmount.value - rolloverValue, response.maturityAmount.currency)
              },
              {
                label: 'rolloverAmount',
                value: this.$formatter.currency.format(rolloverValue, response.maturityAmount.currency)
              }
            )
          }
        }
        // exclude display items
        this.depositDetailsSection2 = this.depositDetailsSection2.filter(item =>
          !this.$appSettings.uiFieldsDisplayConfigurations.termDepositEnquiry.exclusionList.includes(item.label)
        )
      }
    },
    amendDeposit (item1, item2) {
      this.$router.push({
        name: 'TermDepositActions',
        params: {
          product: this.productDetails,
          action: 'amend',
          accountType: this.defaultAccountType,
          routeFrom: location.pathname,
          currentProductSummary: this.currentProductSummary
        }
      })
    },
    breakDeposit (item1, item2) {
      this.$router.push({
        name: 'TermDepositActions',
        params: {
          product: this.productDetails,
          action: 'break',
          accountType: this.defaultAccountType,
          routeFrom: location.pathname
        }
      })
    },
    setTips (accountType) {
      if (accountType === 'TD') {
        this.tips = this.$appSettings.screenTips.deposits
      }
    },
    getMaturityAccount (o) {
      if (!o || ['NOT-APPLICABLE', 'MANUALREDEMPTION'].includes(o.capitalizationMethod)) return 'N/A'

      if (o.capitalizationMethod === 'PAYAWAYINTEREST') {
        return o.payInterestToAccount
      }

      if (o.allowPayAwaytoOtherBank) {
        return `${o.payCapitalToAccount} - ${o.capitalAccountBICId}`
      }

      return o.payCapitalToAccount || 'N/A'
    }
  }
}
</script>
<style scoped>
  .v-tooltip__content {
    max-width: 400px;
    text-align: center;
  }
</style>
